const shoppingCartServiceMixin = {
    data: function () {
        return {
            SHOPPING_CART_BASE: '/api/ShoppingCartApi/'
        }
    },
    methods: {
        updateLineItem: function(data) {
            return this.post(this.SHOPPING_CART_BASE, 'UpdateItem', data);
        },
        deleteItem: function (data) {
            return this.post(this.SHOPPING_CART_BASE, 'RemoveItem', data);
        },
        addConfiguredProductApi: function (data) {
            return this.post(this.SHOPPING_CART_BASE, 'AddConfiguredProduct', data, true);
        },
        addBasicProductApi: function (data) {
            return this.post(this.SHOPPING_CART_BASE, 'AddBasicProduct', data, true);
        },
        addLetteringProductApi: function (data) {
            return this.post(this.SHOPPING_CART_BASE, 'AddLetteringProduct', data, true);
        },
        addVariantItems: function (data) {
            return this.post(this.SHOPPING_CART_BASE, 'AddVariantItems', data, true);
        },
        getShoppingCartCountApi: function () {
            return this.get(this.SHOPPING_CART_BASE, 'GetShoppingCartCount');
        },
        getBasketItems: function () {
            return this.get(this.SHOPPING_CART_BASE, 'GetBasketItems');
        }
    }
}